<template>
  <div>
    <v-tooltip bottom v-if="value !== null">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
            v-bind="attrs"
            v-on="on"
            :color="computedColor"
        >
          {{ computedIcon }}
        </v-icon>
      </template>
      <span v-html="value === '' ? $t('dss.isRecommendation', {catalog: 'app_dashboard'}) : value"></span>
    </v-tooltip>
    <v-icon
        v-else
        :color="computedColor"
    >
      {{ computedIcon }}
    </v-icon>
  </div>
</template>

<script>
/**
 * Component MedicationRecommendationTooltip.vue
 *
 * @module MedicationRecommendationTooltip
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/components/Parts/Medication/MedicationRecommendationTooltip.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'MedicationRecommendationTooltip',
  props: {
    value: {
      type: String,
      required: false,
      default: () => ''
    },
    icon: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      required: false,
    },
  },
  computed: {
    computedIcon() {
      return this.icon ? this.icon : 'mdi-check-decagram'
    },
    computedColor() {
      return this.color ? this.color : 'orange'
    },
  }
};
</script>
